import { onMounted, onBeforeUnmount, ref, type Ref } from "vue"

function useScreenSize(): Ref<number> {
  const screenSize = ref(window.innerWidth)

  function handleResize() {
    screenSize.value = window.innerWidth
  }

  onMounted(() => {
    handleResize()
    if (typeof window !== "undefined") {
      window.addEventListener("resize", handleResize)
    }
  })

  onBeforeUnmount(() => {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", handleResize)
    }
  })

  return screenSize
}

export default useScreenSize
